var site = site || {};

(function ($) {
  Drupal.behaviors.jmDigitalGameVideoV1 = {
    attach: function (context) {
      var $gameContainer = $('.js-digital-game-formatter', context);
      var $videoBanner = $('.js-digital-game-video', $gameContainer);
      var $gameStart = $('.js-digital-game-start', $gameContainer);
      var $gameStartButton = $gameStart.find('.js-start-game');
      var $gameFlow = $('.js-digital-game-flow', $gameContainer);
      var $gameProduct = $('.js-digital-product-start', $gameContainer);
      var $videoSkip = $videoBanner.find('.js-digital-video-skip');
      var $gameOverlay = $('.js-digital-game-overlay', $gameContainer);
      var $gameTerms = $('.js-game-terms', $gameContainer);
      var $gameMatch = $gameOverlay.find('.js-digital-game-flow__match');
      var $gameCard = $gameFlow.find('.digital-game-flow__scene > div');
      var $termsContent = $('.js-terms-content', $gameContainer);
      var $termsCondition = $('.js-terms-conditions', $gameContainer);
      var maxTries = parseInt($gameMatch.data('max-tries'));
      var $noMatchOverlay = $('.js-digital-game__no-match', $gameContainer);
      var $startOverCTA = $noMatchOverlay.find('.js-start-over');
      var $successOverlay = $('.js-digital-game__all-match', $gameContainer);
      var $cardGameOverlay = $('.js-game-overlay', $gameContainer);
      var $selectedOfferMessage = $('.js-selected-offer-message', $gameContainer);
      var $selectedOfferImg = $('.js-selected-offer-img', $gameContainer);
      var $balanceTryAfterMatch = $('.js-balance-try-after-match', $gameContainer);
      var $bodyContent = $('body', context);
      var $html = $('html', context);
      var $redeemOffer = $('.js-redeem-offer', $gameContainer);
      var defaultWaitSeconds = 2;
      var gameOverlayBackgroundClassname = 'digital-game-flow__overlay-background';
      let attemptCount = maxTries;
      let matchedOffer;
      let pauseCard = 0;

      $.fn.shuffle = function () {
        var allElems = this.get();
        var getRandom = function (max) {
          return Math.floor(Math.random() * max);
        };
        var shuffled = $.map(allElems, function () {
          var random = getRandom(allElems.length);
          var randEl = $(allElems[random]).clone(true)[0];

          allElems.splice(random, 1);

          return randEl;
        });

        this.each(function (i) {
          $(this).replaceWith($(shuffled[i]));
        });
        $gameCard.removeClass('is-flipped reveal');
        return $(shuffled);
      };

      $.wait = function (callback, seconds) {
        return window.setTimeout(callback, seconds * 1000);
      };

      $termsCondition.on('click', function (event) {
        event.preventDefault();
        $(this).toggleClass('active');
        $termsContent.toggleClass('active');
      });
      $(document).on('try.again', function (event) {
        event.preventDefault();
        $cardGameOverlay.addClass('hidden');
        $html.removeClass(gameOverlayBackgroundClassname);
        pauseCard = 0;
        if (Drupal.behaviors.jmDigitalGameFormatterV1.redeemed) {
          $.wait(function () {
            $(document).trigger('flipcard.showRedeemedMessage');
            $gameStart.removeClass('hidden').addClass('active');
            $gameFlow.addClass('hidden');
          }, defaultWaitSeconds);
          return false;
        } else if (attemptCount) {
          $('.is-flipped', $gameFlow).find('.js-back-card').removeClass('previous');
          $gameCard.removeClass('is-flipped');
        }
        $successOverlay.find('.js-find-another-match-text').toggleClass('hidden');
        $successOverlay.find('.js-left-now').toggleClass('hidden');
      });
      $('.js-overlay-close').on('click', function () {
        $(document).trigger('try.again');
        if (!attemptCount) {
          $(document).trigger('game.startOver');
        }
      });
      $('.js-try-again').on('click', function () {
        $(document).trigger('try.again');
      });

      $bodyContent.removeClass('offer-banner-enabled');
      $bodyContent.addClass('game-gift-content');

      // Adding style to this class name
      $bodyContent.addClass('digital-holiday-game');

      // Video skip event
      $videoSkip.on('click', function (event) {
        event.preventDefault();
        $videoBanner.slideUp(1500);
        if ($gameProduct.hasClass('already-won')) {
          $gameProduct.addClass('active');
          $bodyContent.removeClass('digital-holiday-game');
        } else {
          $gameStart.addClass('active');
        }
        $gameTerms.addClass('active');
        $gameTerms.removeClass('hidden');
      });

      $gameStartButton.on('click', function (event) {
        event.preventDefault();
        $gameStart.removeClass('active');
        $gameFlow.addClass('active');
        $('.js-back-card', context).shuffle();
      });

      $startOverCTA.on('click', function (event) {
        event.preventDefault();
        $(document).trigger('game.startOver');
        $(document).trigger('try.again');
      });
      $(document).on('game.startOver', function () {
        attemptCount = maxTries;
        $('.js-back-card', context).shuffle();
        $noMatchOverlay.find('.js-try-again').removeClass('hidden');
        $noMatchOverlay.find('.js-start-over, .js-left-now-text').addClass('hidden');
        $gameOverlay.addClass('hidden');
        $html.removeClass(gameOverlayBackgroundClassname);
        $gameCard.addClass('shuffle-card');
        attemptCount = maxTries;
        $gameMatch.empty();
        $gameCard.removeClass('is-flipped reveal');
      });

      $gameCard.on('click', function (event) {
        var $currentCard;
        var $lastCard;
        var offerSelection;
        let $flippedCards = $('.is-flipped', $gameFlow);
        let currentIndex;
        let lastIndex;

        event.preventDefault();
        $gameCard.removeClass('shuffle-card');
        if (!pauseCard) {
          $currentCard = $(this);
          if ($flippedCards.length > 0) {
            attemptCount--;
            pauseCard = 1;
            $lastCard = $flippedCards.find('.previous');
            $currentCard.addClass('is-flipped');
            currentIndex = parseInt($currentCard.find('.js-back-card').data('card-set-index'));
            lastIndex = parseInt($lastCard.data('card-set-index'));
            $flippedCards = $('.is-flipped', $gameFlow);
            if (currentIndex === lastIndex) {
              $flippedCards.addClass('reveal');
              offerSelection = Drupal.behaviors.jmDigitalGameFormatterV1.offerParams[lastIndex];
              $selectedOfferMessage.html(offerSelection.offer_applied_message);
              $selectedOfferImg.attr('src', offerSelection.offer_applied_image);
              matchedOffer = offerSelection.offer_code;
              $balanceTryAfterMatch.text(attemptCount);
              if (attemptCount) {
                $successOverlay
                  .find('.js-try-again-match, .js-find-another-match-text')
                  .removeClass('hidden');
              } else {
                $successOverlay.find('.js-try-again-match, .js-left-now-text').addClass('hidden');
              }
              $.wait(function () {
                $gameMatch.addClass('hidden');
                $successOverlay.removeClass('hidden');
                $html.addClass(gameOverlayBackgroundClassname);

                if ($successOverlay.removeClass('hidden')) {
                  $(document).trigger('eventMatchWin');
                }
              }, defaultWaitSeconds);
            } else {
              $.wait(function () {
                if (attemptCount === 0) {
                  $noMatchOverlay
                    .find('.js-try-again, .js-return-non-zero-match')
                    .addClass('hidden');
                  $noMatchOverlay
                    .find('.js-start-over, .js-return-zero-match, js-left-now-text')
                    .removeClass('hidden');
                  $noMatchOverlay.find('.js-counts-left').text(0);
                } else {
                  $noMatchOverlay.find('.js-counts-left').text(attemptCount);
                }
                $noMatchOverlay.removeClass('hidden');
                $gameMatch.addClass('hidden');
                $html.addClass(gameOverlayBackgroundClassname);
              }, defaultWaitSeconds);
            }
          } else {
            $currentCard.find('.js-back-card').addClass('previous');
            $currentCard.addClass('is-flipped');
          }
        }
      });
      $redeemOffer.on('click', function (event) {
        event.preventDefault;
        $(document).trigger('flipcard.ApplyOffer', [matchedOffer]);
        matchedOffer = '';
      });
      $html.once().on('mousedown', function (event) {
        if (
          $cardGameOverlay.is(':visible') && 
          ($(event.target).parent().hasClass(gameOverlayBackgroundClassname) || $(event.target).closest('.site-header__container').length)
        ) {
          $(document).trigger('try.again');
          if (!attemptCount) {
            $(document).trigger('game.startOver');
          }
        }
      });
    }
  };
})(jQuery);
